import * as Yup from "yup";

import { PRODUCT_GROUPS } from "@/constant/constants";

const BaseProductProductGroupSchema = (productGroup = PRODUCT_GROUPS.JERSEYS) => {
  const jerseySchema = Yup.object().shape({
    sport_id: Yup
      .number()
      .label("Sport")
      .required(),
    product_id: Yup
      .number()
      .label("Product")
      .required(),
    team_id: Yup
      .number()
      .label("Team")
      .required(),
    term_id: Yup
      .number()
      .label("Term")
      .required(),
    edition_id: Yup
      .number()
      .label("Edition")
      .required(),
    // brand_id: Yup
    //   .number()
    //   .label("Brand")
    //   .required(),
  });

  const teamMerchandiseSchema = Yup.object().shape({
    sport_id: Yup
      .number()
      .label("Sport")
      .required(),
    product_id: Yup
      .number()
      .label("Product")
      .required(),
    team_id: Yup
      .number()
      .label("Team")
      .required(),
  });

  const matchBallSchema = Yup.object().shape({
    sport_id: Yup
      .number()
      .label("Sport")
      .required(),
    product_id: Yup
      .number()
      .label("Product")
      .required(),
    competition_id: Yup
      .number()
      .label("Competition")
      .required(),
    term_id: Yup
      .number()
      .label("Term")
      .required(),
    edition_id: Yup
      .number()
      .label("Edition")
      .required(),
  });

  const schemas = {
    [PRODUCT_GROUPS.JERSEYS]: jerseySchema,
    [PRODUCT_GROUPS.TEAM_MERCHANDISE]: teamMerchandiseSchema,
    [PRODUCT_GROUPS.MATCH_BALLS]: matchBallSchema,
  }

  return schemas[productGroup] || schemas[PRODUCT_GROUPS.JERSEYS];
};

export default BaseProductProductGroupSchema;
